export default "__VITE_PUBLIC_ASSET__fd653f8e__"